export default __webpack_public_path__ + "static/media/texture tray.06c1f910.jpg";